import { Card, Box } from "orcs-design-system";
import styled from "styled-components";

/**
 * Get RAG border color from theme
 * @param {string} ragStatus - RAG status ('green', 'amber', 'red', 'grey')
 * @param {object} theme - Theme object
 * @returns {string} - Border color
 */
const getRAGBorderColor = (ragStatus, theme) => {
  const colors = {
    green: theme.colors.success || "#00a86b",
    amber: theme.colors.warning || "#ff9800",
    red: theme.colors.error || "#d32f2f",
    grey: theme.colors.grey || "#ccc",
  };
  return colors[ragStatus] || colors.grey;
};

/**
 * Get RAG background color from theme - using light colors for consistency
 * @param {string} ragStatus - RAG status ('green', 'amber', 'red', 'grey')
 * @param {object} theme - Theme object
 * @returns {string} - Background color
 */
export const getRAGBackgroundColor = (ragStatus, theme) => {
  const colors = {
    green: theme.colors.successLight || "rgba(0, 168, 107, 0.15)",
    amber: theme.colors.warningLight || "rgba(255, 152, 0, 0.15)",
    red: theme.colors.errorLight || "rgba(211, 47, 47, 0.15)",
    grey: theme.colors.greyLighter || "#f5f5f5",
  };
  return colors[ragStatus] || colors.grey;
};

/**
 * Styled Card with RAG status border
 */
export const RAGStyledCard = styled(Card).withConfig({
  shouldForwardProp: (prop) => prop !== "ragStatus",
})`
  ${({ ragStatus, theme }) => `
    border-left: 4px solid ${getRAGBorderColor(ragStatus, theme)};
  `}
  /* Ensure padding is applied correctly */
  box-sizing: border-box;
`;

/**
 * Styled Card with RAG status border and full height
 */
export const RAGStyledCardFullHeight = styled(RAGStyledCard)`
  height: 100%;
`;

/**
 * Icon box with RAG status background
 */
export const RAGIconBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background-color: ${({ ragStatus, theme }) =>
    getRAGBackgroundColor(ragStatus, theme)};
  flex-shrink: 0;
`;
